import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';

export const EventSidebarData = [
  {
    title: 'Home',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text',
  },
  {
    title: 'Event Manager',
    path: 'event-manager',
    icon: <FaIcons.FaUser />,
    cName: 'nav-text',
  },
  {
    title: 'Résztvevő hozzádása',
    path: 'add-new-participant',
    icon: <FaIcons.FaCalendar />,
    cName: 'nav-text',
  },
  {
    title: 'Számláló',
    path: 'counter',
    icon: <FaIcons.FaCalendarAlt />,
    cName: 'nav-text',
  },
];